export default {
    meetNow: "Meet now",
    meetLater: "Schedule meeting",
    currentEvents: "Nyt",
    upcomingEvents: "Muut tänään"
};



//////////////////
// WEBPACK FOOTER
// ./app/ts/i18n/fi.ts
// module id = 228
// module chunks = 0